import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import Typography from "@mui/material/Typography"
import Switch from "@mui/material/Switch"
import TranslatedText from "../../../utils/Translate"
import { useSnackbar } from "../../../utils/SnackbarContext"
import CodeMirror from '@uiw/react-codemirror';
import { materialLight } from "@uiw/codemirror-theme-material"
import { langs } from "@uiw/codemirror-extensions-langs"
import { EditorView } from "@codemirror/view"
import { Paper } from "@mui/material"
import ResizableBlock from "../../../utils/ResizebleBox"

const blackTextTheme = EditorView.theme({
    "&": { color: "#000000" },
    ".cm-content": { color: "#000000" },
    ".cm-line": { color: "#000000" },
})

export default function KnowledgeBase() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [conversationtemplates, setConversationtemplates] = useState([])

    const { showSnackbar } = useSnackbar();

    const [xmlValidation, setXmlValidation] = useState<{ valid: boolean; message: string } | null>(null);

    const validateXML = () => {
        const content = KBData.content || '';
        if (!content.trim()) {
            setXmlValidation({ valid: false, message: 'Content is empty' });
            return;
        }
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(content, 'application/xml');
            const errorNode = doc.querySelector('parsererror');
            if (errorNode) {
                const errorText = errorNode.textContent || 'Unknown XML error';
                setXmlValidation({ valid: false, message: errorText.trim() });
            } else {
                setXmlValidation({ valid: true, message: 'XML is valid' });
            }
        } catch (e: any) {
            setXmlValidation({ valid: false, message: e.message || 'Unknown error' });
        }
    };

    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    const partner = useSelector(
        (state: any) => state.auth.authData.partner
    )



    useEffect(() => {
        //Switch header title
        dispatch(setCurrentPage(type === "edit" ? `Edit Knowledge Base Section` : 'Add Knowledge Base Section'))
    }, [dispatch]);


    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //Get kb
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/knowledgebase/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                setKBData(response.data[0])
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create kb
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/knowledgebase`, {
                ...KBData
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get conversationtemplate for Select field
    async function getConversationtemplates(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data.filter((el: any) => el.showsetuptopartner == '1'));
            setConversationtemplates(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit kb
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/knowledgebase/${id}`, {
                ...KBData
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [KBData, setKBData] = useState<any>(type === 'edit' ? [] :
        {
            "name": null,
            "tags": null,
            "content": null,
            "conversationtemplate": null,
        }
    )



    //On load if URL params contains type=edit load kb data
    useEffect(() => {
        type === 'edit' && fetchData();
        getConversationtemplates();
        console.log(KBData);

    }, [])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ width: 1200, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label"><><TranslatedText text={'Conversation template'} />*</></InputLabel>
                        <Select sx={{ width: 1200 }} labelId="simple-select-label" onChange={(e) => setKBData({ ...KBData, conversationtemplate: e.target.value !== '' ? e.target.value : null })} value={KBData.conversationtemplate || ''} variant="outlined" size="small" label={<><TranslatedText text={'Conversation template'} />*</>} >
                            {
                                (conversationtemplates).map((el: any) => {
                                    //make conversationtemplate list item
                                    return (
                                        <MenuItem key={el.id} value={el.id}>{el.conversationtemplatecode}</MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    <TextField sx={{ width: '100%' }} onChange={(e) => setKBData({ ...KBData, name: e.target.value !== '' ? e.target.value : null })} value={KBData.name || ''} variant="outlined" size="small" label={<><TranslatedText text={'Name'} />*</>} />
                    <TextField multiline rows={2} fullWidth sx={{ width: "100%", "& textarea": { resize: "vertical" } }} onChange={(e) => setKBData({ ...KBData, tags: e.target.value })} value={KBData.tags || ''} variant="outlined" size="small" label={<><TranslatedText text={'Tags'} />*</>} />
                    <Box sx={{ width: "100%", position: "relative", overflow: "visible" }}>
                        <Typography variant="caption" sx={{ position: "absolute", top: -10, left: 10, zIndex: 1, backgroundColor: "white", px: 0.5, color: "rgba(0,0,0,0.6)", lineHeight: 1 }}>
                            <TranslatedText text={'Content'} />*
                        </Typography>
                        <Box sx={{ borderRadius: 1, overflow: "visible", "&:hover": { borderColor: "rgba(0,0,0,0.87)" }, "&:focus-within": { borderColor: "primary.main", borderWidth: 2 } }}>
                            <ResizableBlock initialHeight={500} initialWidth={1200}>
                                <CodeMirror
                                    value={KBData.content || ''}
                                    height="100%"
                                    style={{ height: "100%"}}
                                    theme={materialLight}
                                    extensions={[blackTextTheme]}
                                    onChange={(value) => setKBData({ ...KBData, content: value })}
                                    basicSetup={{ lineNumbers: true, foldGutter: false }}
                                />
                            </ResizableBlock>
                        </Box>
                    </Box>
                </Box>
                <Button disabled={partner == "80"} onClick={() => type === "edit" ? putData(KBData) : postData(KBData)} variant="contained" sx={{ width: "100%" }}><TranslatedText text={'Save'} /></Button>
                <Button onClick={validateXML} variant="outlined" sx={{ width: "100%", mt: 1 }}><TranslatedText text={'Check XML'} /></Button>
                {xmlValidation && (
                    <Alert severity={xmlValidation.valid ? 'success' : 'error'} sx={{ mt: 1, width: 1200, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }} onClose={() => setXmlValidation(null)}>
                        {xmlValidation.message}
                    </Alert>
                )}
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/knowledgebases' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        <TranslatedText text={'Saving error'} />
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        <TranslatedText text={'Successfully saved'} />
                    </Alert>}
            </Snackbar>
        </Box >
    )
}